import styled from "styled-components"

import { maxWidth, eq } from "utils"

import CloudinaryImage from "components/cloudinary-image"

export const Container = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};
  color: ${(props) => props.theme.component.text};

  > div {
    position: relative;
  }

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }
`

export const Background = styled(CloudinaryImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${maxWidth.mobile`
    height: 50%;
  `}
`

export const HeadingGradient = styled.div`
  cursor: ${(props) => !props.hidePlayButton && "pointer"};
`

export const Subheading = styled.div`
  /* empty */
`

export const ButtonContainer = styled.div`
  padding: 3.3rem 0 0 0;

  ${maxWidth.mobile`
    padding: 3.3rem 0;
  `}

  button {
    margin: 0 auto;

    ${maxWidth.mobile`
      max-width: 90%;
    `}
  }
`

export const TopSpacer = styled.div`
  cursor: ${(props) => !props.hidePlayButton && "pointer"};
`

export const BottomSpace = styled.div`
  padding: 2.5rem 0;
  background-color: ${(props) => props.theme.component.background};
`

export const FeatureHighlights = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5rem;

  ${maxWidth.mobile`
    display: none;
  `}
`

export const FeatureHighlightsMobile = styled.section`
  display: none;
  flex-direction: column;
  color: ${(props) => props.theme.component.text};
  background-color: ${(props) => props.theme.component.background};

  ${maxWidth.mobile`
    display: flex;
  `}
`

export const FeatureSpacer = styled.div`
  height: 12rem;
  width: 0.01rem;
  margin: 0 1.7rem;
  background: currentColor;

  ${maxWidth.mobile`
    display: none;
  `}
`

export const Feature = styled.div`
  text-align: center;
  max-width: 20rem;

  ${maxWidth.tablet`
    max-width: 16rem;
  `}

  ${maxWidth.mobile`
    max-width: 30rem;
    margin: 0 auto;
    margin-bottom: 3.5rem;
  `}

  h5 {
    font-size: 1.4rem;
    letter-spacing: 0.017rem;
    text-transform: uppercase;
    margin-bottom: 0.7rem;

    ${maxWidth.mobile`
      font-size: 1.9rem;
      line-height: 2.8rem;
    `}
  }

  span {
    font-size: 1.35rem;
    letter-spacing: 0.021rem;

    ${maxWidth.mobile`
      font-size: 1.8rem;
      line-height: 2.7rem;
    `}
  }
`

export const Content = styled.div`
  position: relative;
  text-align: center;

  ${TopSpacer} {
    padding: 7rem 0 0;
  }

  ${eq("variant", "Large")`
    ${TopSpacer} {
      padding: 20rem 0 0;
    }

    ${HeadingGradient} {
      background-image: linear-gradient(rgba(255,255,255,0) 0, ${(props) =>
        props.theme.component.background} 78%, ${(props) => props.theme.component.background} 96%);
    }

    ${Subheading},
    ${ButtonContainer},
    ${FeatureHighlights},
    ${FeatureHighlightsMobile} {
      background-color: ${(props) => props.theme.component.background};
    }
  `}

  ${eq("variant", "Small")`
    background-image: linear-gradient(
      to top,
      rgba(34, 34, 34, 0.9),
      rgba(0, 0, 0, 0.65),
      rgba(0, 0, 0, 0)
    );

    padding-bottom: 5rem;
  `}

  h1 {
    max-width: 75rem;
    margin: 0 auto;
    font-size: 5.4rem;
    line-height: 1.35;

    ${maxWidth.mobile`
      font-size: 4rem;
      max-width: 90%;
      font-size: 3.4rem;
    `}
  }

  p {
    font-size: ${(props) => (props.hidePlayButton ? "4.5rem" : "1.8rem")};
    line-height: 4.2rem;
    max-width: 90%;
    letter-spacing: -1px;
    margin: ${(props) => (props.hidePlayButton ? "10px auto 120px auto" : "0 auto")};
    padding-top: 0.75em;

    ${maxWidth.mobile`
      margin: 0 auto;
      font-size: 2rem;
      line-height: 1.3;
      max-width: 90%;
    `}
  }

  span {
    font-weight: bold;
  }
`

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  transition: transform 0.3s ease-in-out;
  margin-bottom: 5rem;

  ${maxWidth.mobile`
    margin: 3.8rem 0;
    display: ${(props) => props.hidePlayButton && "none"};
  `}

  &:hover {
    transform: scale(1.1);
    transition: transform 0.3s ease-in-out;
  }
`

export const FeatureImage = styled(CloudinaryImage)`
  margin: 0 auto;
  width: 3rem;
  height: ${(props) => props.aspectRatio * 3}rem;
  margin-bottom: 1.3rem;
`

export const PlayText = styled.div`
  visibility: hidden;
  color: ${(props) => props.theme.colors.text.primary};
  text-transform: uppercase;
  font-size: 1.5rem;
  font-weight: 800;

  ${IconContainer}:hover & {
    visibility: visible;
  }
`
